import { useStoneAccountDetailbyCompany } from '@/core/domain/stone/stoneAccount/stoneAccount.hooks';
import { useWindowSize } from '@/hooks';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Card, Col, Row } from 'antd';
import './style.less';
import { useCompanyTefConfiguration } from '@/core/domain/enterprise/companyTefConfiguration/companyTefConfiguration.hooks';
import { useEffect } from 'react';
import { useWorkorderConfigurationCompanyQuery } from '@/core/domain/workorder/WorkordersConfiguration/WorkordersConfiguration.hooks';
import UserGuiding from '@/core/UserGuinding';

export enum FinancialType {
  Default = 'default',
  Stone = 'stone',
  Tef = 'tef',
}

interface Props {
  type: FinancialType;
  onChange(type: FinancialType): void;
  companyId?: number;
  visible: boolean;
  tefEnabled: boolean;
}

export default function FinancialTypeGenerate(props: Props) {
  const { data: companySetting } = useWorkorderConfigurationCompanyQuery(
    props?.companyId,
  );
  const { data: stoneAccount } = useStoneAccountDetailbyCompany(
    props?.companyId,
  );
  const { data: tefConfig } = useCompanyTefConfiguration(
    props.companyId,
    props.visible,
  );

  const { isMobile } = useWindowSize();

  const stoneEnabled =
    !!companySetting?.isInstallmentFree &&
    !!stoneAccount?.active &&
    hasPermissions([Authorities.STONE_ORDER_CREATE]);

  const hasTefPermission = hasPermissions([Authorities.REGISTER_PAYMENTS_TEF]);
  const tefVisible = !isMobile && hasTefPermission && tefConfig?.active;

  useEffect(() => {
    if (tefVisible && props.tefEnabled) {
      UserGuiding.showTEFGuide();
    }
  }, [tefVisible, props.tefEnabled]);

  const options = [
    {
      label: 'Financeiro manual',
      value: FinancialType.Default,
      visible: true,
    },
    {
      label: 'Financeiro Stone',
      value: FinancialType.Stone,
      visible: stoneEnabled,
    },
    {
      label: 'Financeiro TEF',
      value: FinancialType.Tef,
      visible: tefVisible,
      disabled: !props.tefEnabled,
    },
  ];

  const optionsFiltered = options.filter((option) => option.visible);

  if (!props.visible || optionsFiltered.length === 1) return null;

  return (
    <Row gutter={16} style={{ marginBottom: 16 }}>
      {optionsFiltered.map((option) => (
        <Col
          span={24 / optionsFiltered.length}
          key={option.value}
          id={`financial-type-col-${option.value}`}
        >
          <Card
            id={`financial-type-card-${option.value}`}
            data-active={option.value === props.type}
            data-disabled={option.disabled}
            className="financial-type-card"
            bodyStyle={{ textAlign: 'center' }}
            hoverable
            aria-disabled={option.disabled}
            onClick={() => !option.disabled && props.onChange(option.value)}
          >
            <span>{option.label}</span>
          </Card>
        </Col>
      ))}
    </Row>
  );
}
